// hooks/useUserData.js
import { useState, useEffect } from "react";

interface UserData {
  email: string;
  name: string;
  picture: string;
}

const useUserData = (): UserData | null => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const getMenteeData = () => {
      let userData = localStorage.getItem("mentee_data");
      if (userData) {
        try {
          setUserData(JSON.parse(userData));
        } catch (e) {
          console.error("Error parsing mentee_data from localStorage:", e);
          setUserData(null);
        }
      } else {
        setUserData(null);
      }
    };

    getMenteeData();
  }, []);

  return userData;
};

export function useSessionStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn("Error reading sessionStorage key", key);
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    try {
      setStoredValue(value);
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn("Error setting sessionStorage key", key);
    }
  };

  return [storedValue, setValue] as const;
}

export default useUserData;
